import React from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { useOverlays } from "../../../contexts/OverlayContext";

export const ReferralDrawerTrigger: React.FC = () => {
    const { openOverlay } = useOverlays();

    const triggerReferralModal = () => {
        openOverlay("referralDrawer", true);
    };

    return (
        <Menu.Item onClick={triggerReferralModal}>Refer &amp; earn</Menu.Item>
    );
};
